import { create } from 'zustand';
import { listDevices, ApiVendoDevice } from '@/api/vendo';

interface State {
   devices: ApiVendoDevice[];
   loading: boolean;
   error: string | null;
   fetched: boolean;
   fetch: () => Promise<void>;
   patchDeviceName: (id: string, name: string) => void;
}

export const useVendoDevicesStore = create<State>((set) => ({
   devices: [],
   loading: false,
   error: null,
   fetched: false,
   fetch: async () => {
      set({ loading: true, error: null });
      try {
         const res = await listDevices();
         set({ devices: res.devices, loading: false, fetched: true });
      } catch (err: unknown) {
         const msg =
            (err as { response?: { data?: { error?: string } } })?.response?.data?.error ||
            (err as Error)?.message ||
            'Failed to load devices';
         set({ error: msg, loading: false, fetched: true });
      }
   },
   patchDeviceName: (id, name) =>
      set((state) => ({
         devices: state.devices.map((d) => (d._id === id ? { ...d, name } : d)),
      })),
}));
